"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Text = (0, _styledComponents["default"])(_Text["default"])(_templateObject(), function (p) {
  var typography = p.typography ? p.theme.typography[p.typography] : p.theme.typography.bodyText;
  return typography;
}, function (p) {
  return p.color ? "color: ".concat(p.theme.colors[p.color] || p.color, ";") : "";
});
exports.Text = Text;